// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__1lgIz","item":"PaymentsMobile_item__3p4ZN","label":"PaymentsMobile_label__guowm","amount":"PaymentsMobile_amount__3GnZz"};